import React, { useState } from 'react';
import './services.css';

const Services = () => {
  const [toggleState, setToggleState] = useState(0);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className='services section' id='services'>
      <h2 className='section__title'>Services</h2>
      <span className='section__subtitle'>What I offer</span>

      <div className='services__container container grid'>
        {/* 1) MLOps Pipelines */}
        <div className='services__content'>
          <div>
            <i className='uil uil-setting services__icon'></i>
            <h3 className='services__title'>
              MLOps <br /> Pipelines
            </h3>
          </div>

          <span className='services__button' onClick={() => toggleTab(1)}>
            View More
            <i className='uil uil-arrow-right services__button-icon'></i>
          </span>

          <div className={toggleState === 1 ? 'services__modal active-modal' : 'services__modal'}>
            <div className='services__modal-content'>
              <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

              <h3 className='services__modal-title'>MLOps Pipelines</h3>
              <p className='services__modal-description'>
                Building reproducible ML workflows: training, experiment tracking, versioning, CI/CD, and deployment.
              </p>

              <ul className='services__modal-services grid'>
                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Experiment tracking with MLflow (metrics, params, artifacts)</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Data/model versioning with DVC for reproducible runs</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>CI/CD with GitHub Actions for tests, linting, and builds</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Containerized ML services using Docker and deployment patterns</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 2) GenAI / RAG Systems */}
        <div className='services__content'>
          <div>
            <i className='uil uil-robot services__icon'></i>
            <h3 className='services__title'>
              GenAI / RAG <br /> Systems
            </h3>
          </div>

          <span onClick={() => toggleTab(2)} className='services__button'>
            View More
            <i className='uil uil-arrow-right services__button-icon'></i>
          </span>

          <div className={toggleState === 2 ? 'services__modal active-modal' : 'services__modal'}>
            <div className='services__modal-content'>
              <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

              <h3 className='services__modal-title'>GenAI / RAG Systems</h3>
              <p className='services__modal-description'>
                Designing retrieval-augmented generation solutions for document Q&A with evaluation and safe prompting.
              </p>

              <ul className='services__modal-services grid'>
                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Document ingestion + chunking + embeddings pipeline</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Vector search with Azure AI Search (or local vector stores)</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>LangChain orchestration + prompt design (Prompt Flow-ready)</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Evaluation mindset: relevance, groundedness, and hallucination checks</p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 3) Azure Deployment & Data Pipelines */}
        <div className='services__content'>
          <div>
            <i className='uil uil-cloud services__icon'></i>
            <h3 className='services__title'>
              Azure Deployment <br /> & Data Pipelines
            </h3>
          </div>

          <span onClick={() => toggleTab(3)} className='services__button'>
            View More
            <i className='uil uil-arrow-right services__button-icon'></i>
          </span>

          <div className={toggleState === 3 ? 'services__modal active-modal' : 'services__modal'}>
            <div className='services__modal-content'>
              <i onClick={() => toggleTab(0)} className='uil uil-times services__modal-close'></i>

              <h3 className='services__modal-title'>Azure Deployment & Data Pipelines</h3>
              <p className='services__modal-description'>
                Deploying APIs and building data pipelines using Azure services with clear documentation and reliability.
              </p>

              <ul className='services__modal-services grid'>
                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>FastAPI model inference APIs and integration-ready endpoints</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Deploy containers to Azure Container Apps (Docker-based workflows)</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>ETL pipelines with Airflow and scheduling/monitoring patterns</p>
                </li>

                <li className='services__modal-service'>
                  <i className='uil uil-check-circle services__modal-icon'></i>
                  <p className='services__modal-info'>Blob Storage pipelines: upload, read, and data movement workflows</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
